import { FacilityBaleProcessedPage } from '@/pages/facility/workflows/bale-processed';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/facility/bale-processed')({
	component: FacilityBaleProcessedPage,
});
